<template>
  <div>
    <div class="p-8 bg-gray-800">
      <div class="max-w-7xl mx-auto">
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex-1 min-w-0">
            <h2 class="text-2xl font-bold leading-7 text-white sm:text-3xl sm:truncate">Tags</h2>
          </div>
          <div class="mt-4 flex md:mt-0 md:ml-4 space-x-2">
            <!-- Create Tag Action -->
          </div>
        </div>
      </div>
    </div>
    <div class="p-8">
      <div class="max-w-7xl mx-auto">
        <TagListByCategory
          :categories-client="tagCategoriesClient"
          :category-tags-client="tagCategoryTagsClient"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { tagCategoryTagsClient, tagCategoriesClient } from '@/api/clients/admin';
import components from './components';

export default {
  components,
  data() {
    return {
      tagCategoriesClient,
      tagCategoryTagsClient,
    };
  },
};
</script>
